import React from 'react';
import loadable from '@loadable/component';
import { colors } from '@naf-simba/theme';
import { MapV2 } from '@components/SectionBlocks/blocks/Charts/MapV2';
import { PointOfInterest } from '@components/SectionBlocks/blocks/Charts/RouteCharts';
import { useElPrixRouteData } from '@hooks/useElPrixRouteData';
import * as S from './RouteMapSerializer.styles';

const GoogleMapsWrapper = loadable(() => import('@components/SectionBlocks/blocks/Charts/GoogleMapsWrapper'), {
  resolveComponent: (m) => m.GoogleMapsWrapper,
});

type Props = {
  inArticle?: boolean;
  value: {
    _key: string;
    _type: 'routeMap';
  } & (CustomRouteMapData | TestRouteMapData);
};

type TestRouteMapData = {
  useRouteFromTest: true;
  elPrixTestReference: { routepoints: PointOfInterest[]; altitudeProfile: number[] };
};
type CustomRouteMapData = { useRouteFromTest: false; routepoints: PointOfInterest[]; altitudeProfile: number[] };

const RouteMapSerializer =
  () =>
  ({ value, inArticle }: Props) => (
    <GoogleMapsWrapper>
      <RenderRouteMap value={value} inArticle={inArticle || false} />
    </GoogleMapsWrapper>
  );

const RenderRouteMap = ({ value, inArticle }: Props) => {
  const { routepoints, altitudeProfile } = value.useRouteFromTest === true ? value.elPrixTestReference : value;

  const { pointsOfInterest, routeData, isLoading } = useElPrixRouteData({
    routepoints,
    elevation: altitudeProfile,
  });

  return (
    <S.MapContainer inArticle={inArticle}>
      <MapV2
        animate
        mapOptions={{
          animatedPathStroke: colors.secondary[500],
        }}
        routeData={routeData}
        pointsOfInterest={pointsOfInterest}
        isLoading={isLoading}
        zoom={6}
        center={{ lat: 61.26921, lng: 10.40559 }}
        style={{ height: '100%' }}
      />
    </S.MapContainer>
  );
};

export { RouteMapSerializer };
